import { useState, useEffect } from "react";
import axios from "../axiosConfig";
import { useToast } from "@chakra-ui/react";

const useChecklistItems = (interpretationId) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  const fetchItems = async () => {
    if (!interpretationId) return;
    setLoading(true);
    try {
      const response = await axios.get(`/interpretations/${interpretationId}/checklist_items`);
      setItems(response.data || []);
    } catch (error) {
      toast({ title: "Error loading checklist items.", status: "error" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, [interpretationId]);

  const createItem = async (data) => {
    try {
      const response = await axios.post(`/interpretations/${interpretationId}/checklist_items`, {
        checklist_item: data,
      });
      setItems((prev) => [...prev, response.data]);
      toast({ title: "Checklist item created.", status: "success" });
    } catch (error) {
      toast({ title: "Error creating checklist item.", status: "error" });
    }
  };

  const updateItem = async (id, data) => {
    try {
      const response = await axios.patch(
        `/interpretations/${interpretationId}/checklist_items/${id}`,
        { checklist_item: data }
      );
      setItems((prev) =>
        prev.map((item) => (item.id === id ? response.data : item))
      );
      toast({ title: "Checklist item updated.", status: "success" });
    } catch (error) {
      toast({ title: "Error updating checklist item.", status: "error" });
    }
  };

  const deleteItem = async (id) => {
    try {
      await axios.delete(`/interpretations/${interpretationId}/checklist_items/${id}`);
      setItems((prev) => prev.filter((item) => item.id !== id));
      toast({ title: "Checklist item deleted.", status: "info" });
    } catch (error) {
      toast({ title: "Error deleting checklist item.", status: "error" });
    }
  };

  return { items, loading, createItem, updateItem, deleteItem, fetchItems };
};

export default useChecklistItems;